import React from 'react'

const Title = ({headline}) => {
  return (
    <h1 className='my-3 text-center'>{headline}</h1>
  )

}

export default Title